(function () {
  class BigWinNew extends PIXI.Container {
    constructor() {
      super();

      this._level1Threshold = 20;
      this._level2Threshold = 50;
      this._level3Threshold = 100;
      this._level4Threshold = 200;
      this._level5Threshold = 500;

      this._level1ThresholdBAB = 2;
      this._level2ThresholdBAB = 5;
      this._level3ThresholdBAB = 7.5;
      this._level4ThresholdBAB = 10;
      this._level5ThresholdBAB = 25;

      this._level1ThresholdBAB_Xtra = 1.5;
      this._level2ThresholdBAB_Xtra = 2.5;
      this._level3ThresholdBAB_Xtra = 3;
      this._level4ThresholdBAB_Xtra = 5;
      this._level5ThresholdBAB_Xtra = 10;

      this.bigWinLevel = [
        {
          bigWinType: 'BIGWIN',
          countTime: 5,
          threshold: this._level1Threshold,
          thresholdBAB: this._level1ThresholdBAB,
          thresholdBAB_Xtra: this._level1ThresholdBAB_Xtra,
          state: 'INITBIGWIN',
        },
        {
          bigWinType: 'HUGEWIN',
          countTime: 7,
          threshold: this._level2Threshold,
          thresholdBAB: this._level2ThresholdBAB,
          thresholdBAB_Xtra: this._level2ThresholdBAB_Xtra,
          state: 'INITBIGWIN',
        },
        {
          bigWinType: 'MASSIVEWIN',
          countTime: 9,
          threshold: this._level3Threshold,
          thresholdBAB: this._level3ThresholdBAB,
          thresholdBAB_Xtra: this._level3ThresholdBAB_Xtra,
          state: 'INITBIGWIN',
        },
        {
          bigWinType: 'EPICWIN',
          countTime: 11,
          threshold: this._level4Threshold,
          thresholdBAB: this._level4ThresholdBAB,
          thresholdBAB_Xtra: this._level4ThresholdBAB_Xtra,
          state: 'INITBIGWIN',
        },
        {
          bigWinType: 'MONSTERWIN',
          countTime: 13,
          threshold: this._level5Threshold,
          thresholdBAB: this._level5ThresholdBAB,
          thresholdBAB_Xtra: this._level5ThresholdBAB_Xtra,
          state: 'INITBIGWIN',
        },
      ];

      this.bigWinState = 'IDLE';

      this.isActive = false;
      this.skipWin = false;
      this.allowSkipWin = false;

      this.currentLevel = 0;

      this._thresholdMultiplier = 0;

      this.scaleIncrease = 0;

      this.winAmount = 0;

      this.callback = undefined;

      this.recScale = 0;

      this.startDelay = 0;

      this.bounceCounter = 0;
      this.bounceRate = Math.PI * 0.05;

      const self = this;

      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState('IDLE', function () {});

      this.stateMachine.addState('LOSSWIN', function () {
        self.update_LossWinState();
      });

      this.stateMachine.addState('LOWWIN', function () {
        self.update_LowWinState();
      });

      this.stateMachine.addState('MIDWIN', function () {
        self.update_MidWinState();
      });

      this.stateMachine.addState('SHOWWINENDING', function () {
        self.update_showWinText();
      });

      this.stateMachine.addState('INITBIGWIN', function () {
        self.update_initBigWin();
      });

      this.stateMachine.addState('BIGWIN', function () {
        self.update_bigWin();
      });

      this.stateMachine.addState('HUGEWIN', function () {
        self.update_hugeWin();
      });

      this.stateMachine.addState('MASSIVEWIN', function () {
        self.update_massiveWin();
      });

      this.stateMachine.addState('EPICWIN', function () {
        self.update_epicWin();
      });

      this.stateMachine.addState('MONSTERWIN', function () {
        self.update_monsterWin();
      });

      this.stateMachine.addState('BOUNCEANDGROW', function () {
        self.update_bounceAndGrow();
      });

      this.stateMachine.addState('ENDSTAGE', function () {
        self.update_endStage();
      });
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    getBigWinThreshold() {
      let threshold = this._level1Threshold;
      if (gameController.inBuyABonusNormal) {
        threshold = this._level1ThresholdBAB;
      } else if (gameController.inBuyABonusExtra) {
        threshold = this._level1ThresholdBAB_Xtra;
      }
      return threshold;
    }

    getHugeWinThreshold() {
      let threshold = this._level2Threshold;
      if (gameController.inBuyABonusNormal) {
        threshold = this._level2ThresholdBAB;
      } else if (gameController.inBuyABonusExtra) {
        threshold = this._level2ThresholdBAB_Xtra;
      }
      return threshold;
    }

    getMassiveWinThreshold() {
      let threshold = this._level3Threshold;
      if (gameController.inBuyABonusNormal) {
        threshold = this._level3ThresholdBAB;
      } else if (gameController.inBuyABonusExtra) {
        threshold = this._level3ThresholdBAB_Xtra;
      }
      return threshold;
    }

    getEpicWinThreshold() {
      let threshold = this._level4Threshold;
      if (gameController.inBuyABonusNormal) {
        threshold = this._level4ThresholdBAB;
      } else if (gameController.inBuyABonusExtra) {
        threshold = this._level4ThresholdBAB_Xtra;
      }
      return threshold;
    }

    getMonsterWinThreshold() {
      let threshold = this._level5Threshold;
      if (gameController.inBuyABonusNormal) {
        threshold = this._level5ThresholdBAB;
      } else if (gameController.inBuyABonusExtra) {
        threshold = this._level5ThresholdBAB_Xtra;
      }
      return threshold;
    }

    checkBigWin(amount) {
      const threshold = gameController.globalHelperGetStake() * this.getBigWinThreshold();
      return amount >= threshold;
    }

    init() {
      this._dimScreen = resourceManager.get('bigWinDimObject');
      this._dimScreen.show(false);

      this._bigWinContainer = resourceManager.getContainer('bigWinContainer');
      this._bigWinContainer.visible = false;

      this._winAwardTextBack = resourceManager.get('bigWin:awardText');
      this._winAwardTextBack.visible = false;

      this._awardTextBackOffset = 10;

      this._bigWinTextContainer = resourceManager.get('bigWin:bigWinTextContainer');
      this._bigWinTextContainer.visible = false;

      this._hugeWinTextContainer = resourceManager.get('bigWin:hugeWinTextContainer');
      this._hugeWinTextContainer.visible = false;

      this._massiveWinTextContainer = resourceManager.get('bigWin:massiveWinTextContainer');
      this._massiveWinTextContainer.visible = false;

      this._epicWinTextContainer = resourceManager.get('bigWin:epicWinTextContainer');
      this._epicWinTextContainer.visible = false;

      this._monsterWinTextContainer = resourceManager.get('bigWin:monsterWinTextContainer');
      this._monsterWinTextContainer.visible = false;

      this._starParticles = particleManager.createEmitter(
        'bigwin_stars_emitter',
        'bigWin:bigWinParticlesContainer',
        0,
        0,
        false
      );
      this._starParticles.particleEmitter.emit = false;
      this._starParticles.visible = false;

      this._electricParticles = particleManager.createEmitter(
        'bigwin_electric_emitter',
        'bigWin:bigWinParticlesContainer',
        0,
        -100,
        false
      );
      this._electricParticles.particleEmitter.emit = false;
      this._electricParticles.visible = false;

      this._skipBigWinBox = resourceManager.get('bigWin:skipBigWinBox');

      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.visible = false;
      this._skipBigWinBox.interactive = false;

      this._glow = resourceManager.get('bigWin:glowRays');
      this._glowTween = gsap.to(this._glow, {
        rotation: '+=1',
        duration: 1,
        repeat: -1,
      });
      this._glowTween.pause();

      this._cappedWinPopup = resourceManager.get('maxWinPopup');
      this._cappedWinPopup.visible = false;
      this._cappedWinPopupButton = resourceManager.get('maxWinPopup:continueButton');
      this._cappedWinPopupButton.interactive = false;

      this._awardTextFinalPos = resourceManager.get('bigWin:awardTextFinalPos');
      this._awardTextStartPos = resourceManager.get('bigWin:awardTextStartPos');
    }

    isBigWinActive() {
      return this.isActive;
    }

    showCappedWinPopup(callback) {
      this._cappedWinPopup.visible = true;
      this._cappedWinPopup.alpha = 0;
      this.isActive = true;

      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          self._dimScreen.show(true);
          self._dimScreen.alpha = progress * 0.6;
          self._cappedWinPopup.alpha = progress;
        },
        function () {
          self._dimScreen.show(true);
          self._dimScreen.alpha = 0.6;
          self._cappedWinPopup.alpha = 1;

          self._cappedWinPopupButton.interactive = true;
          self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = function () {
            self._cappedWinPopup.visible = false;
            self._dimScreen.show(false);
            self._cappedWinPopupButton.interactive = false;
            self._cappedWinPopupButton.touchend = self._cappedWinPopupButton.mouseup = function () {};
            callback();
          };
        }
      );
    }

    start(winAmount, callback, capped) {
      if (capped) {
        const self = this;
        this.showCappedWinPopup(function () {
          self.startBigWin(winAmount, callback);
        });
      } else {
        this.startBigWin(winAmount, callback);
      }
    }

    startBigWin(winAmount, callback, capped) {
      musicManager.onBigWinStart();

      this.callback = callback;
      this.winAmount = winAmount;

      this.startDelay = 0; //startDelay !== undefined ? startDelay : 0;

      this.isActive = true;
      this.skipWin = false;
      this.allowSkipWin = false;

      this.currentLevel = 0;
      this.scaleIncrease = 0;

      this._winAwardTextBack.alpha = 1.0;

      this._bigWinContainer.visible = true;

      this.visible = true;

      const stake = gameController.globalHelperGetStake();

      this.currentState = undefined;

      for (var i = this.bigWinLevel.length - 1; i >= 0; i--) {
        let threshold = this.bigWinLevel[i].threshold;
        if (gameController.inBuyABonusNormal) {
          threshold = this.bigWinLevel[i].thresholdBAB;
        } else if (gameController.inBuyABonusExtra) {
          threshold = this.bigWinLevel[i].thresholdBAB_Xtra;
        }

        if (this.winAmount >= threshold * stake) {
          this.targetLevel = this.bigWinLevel[i].bigWinId;

          this.currentState = this.bigWinLevel[i].state;
          break;
        }
      }

      this._skipBigWinBox.visible = true;
      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.interactive = true;
      this._skipBigWinBox.mousedown = this._skipBigWinBox.touchstart = this.skip.bind(this);

      this.stateMachine.switchState(this.currentState);

      this._glowTween.play();

      this._dimScreen.show();
      this._dimScreen.setAlpha(0);
      let self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          self._dimScreen.setAlpha(0.7 * progress);
        },
        function () {
          self._dimScreen.setAlpha(0.7);
        }
      );
    }

    canSkip() {
      return this.isActive && !this.skipWin && this.allowSkipWin;
    }

    update_LossWinState() {
      if (this.phase.once()) {
        this.allowSkipWin = true;

        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.set(this.winAmount);
        this._winAwardTextBack.alpha = 1;
        this._winAwardTextBack.visible = true;

        this._finalScaleX = 1.0;
        this._finalScaleY = 1.0;
      }

      if (this.phase.timed(700)) {
        if (this.skipWin) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('SHOWWINENDING');
      }
    }

    update_LowWinState() {
      if (this.phase.once()) {
        musicManager.startCountUp();
        this.allowSkipWin = true;

        this._winAwardTextBack.set(this.winAmount);
        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        this._finalScaleX = 1;
        this._finalScaleY = 1;
      }

      // are we skipping the win
      if (this.skipWin) {
        this.stateMachine.switchState('SHOWWINENDING');
      }

      // scale up and fade in
      if (this.phase.timed(500)) {
        this._winAwardTextBack.scale.x = 1.0 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1.0 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.alpha = this.phase.Progress;
      }

      // scale back down
      if (this.phase.timed(142)) {
        this._winAwardTextBack.scale.x = 1.5 - 0.3 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1.5 - 0.3 * this.phase.Progress;
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('SHOWWINENDING');
      }

      // end phase
      if (this.phase.exit()) {
        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
        this._winAwardTextBack.alpha = 1;
      }
    }

    update_MidWinState() {
      if (this.phase.once()) {
        musicManager.startCountUp();
        this.allowSkipWin = true;

        this._winAwardTextBack.set(0);
        this._winAwardTextBack.scale.x = 5;
        this._winAwardTextBack.scale.y = 5;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        const stake = gameController.globalHelperGetStake();

        const maxTime = 3000;
        const minTime = 1000;
        const deltaTime = maxTime - minTime;
        const maxValue = 20 * stake;
        const minValue = 3 * stake;

        const normalisedWin = this.winAmount - minValue;
        const normalisedMax = maxValue - minValue;
        const ratio = normalisedWin / normalisedMax;

        function clamp(val, min, max) {
          return val > max ? max : val < min ? min : val;
        }

        const countUpTime = clamp(ratio * deltaTime + minTime, minTime, maxTime);

        const bounceGrowTime = 500;
        const bounceShrinkTime = 142;
        const totalBounceTime = bounceGrowTime + bounceShrinkTime;
        const totalCountTime = totalBounceTime + countUpTime;
        const lingerTime = 500;

        this._winAwardTextBack.countUp(this.winAmount, countUpTime);
      }

      // skip win and force countup to final value
      if (this.skipWin) {
        this.stateMachine.switchState('SHOWWINENDING');
        musicManager.endCountUp();
        this._winAwardTextBack.cancelCountUp();
      }

      // scale up and fade in
      if (this.phase.timed(500)) {
        this._winAwardTextBack.scale.x = 0.5 + 0.7 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 0.5 + 0.7 * this.phase.Progress;
        this._winAwardTextBack.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
        this._winAwardTextBack.alpha = 1;
      }

      // bounce down
      if (this.phase.timed(142)) {
        this._winAwardTextBack.scale.x = 1 - 0.2 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1 - 0.2 * this.phase.Progress;
      }

      if (this.phase.once()) {
        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
      }

      // bounce back to 1.2x
      if (this.phase.timed(200)) {
        this._winAwardTextBack.scale.x = 1 + this.phase.Progress * 0.2;
        this._winAwardTextBack.scale.y = 1 + this.phase.Progress * 0.2;
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('SHOWWINENDING');
      }

      if (this.phase.exit()) {
        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
        this._winAwardTextBack.alpha = 1;
      }
    }

    update_showWinText() {
      // we can't skip the final tidy up of the value
      if (this.phase.once()) {
      }

      if (this.phase.timed(750)) {
        // let the player see their win - do nothing
      }

      // now move the text down and fade off
      if (this.phase.timed(300)) {
      }

      if (this.phase.once()) {
        musicManager.endCountUp();
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('IDLE');
      }

      if (this.phase.exit()) {
        this._winAwardTextBack.position.setY(this._awardTextFinalPos.position.getY());
        this._winAwardTextBack.alpha = 1;
        this._winAwardTextBack.visible = false;

        if (this.callback) {
          this.isActive = false;
          this.callback();
          this.callback = undefined;
        }
      }
    }

    update_initBigWin() {
      const startScale = 0;

      if (this.phase.enter()) {
      }

      if (this.phase.timed(this.startDelay)) {
      }

      if (this.phase.once()) {
        this._electricParticles.particleEmitter.emit = true;
        this._electricParticles.visible = true;

        this._currentPanel = this._bigWinTextContainer;
        this._currentPanel.alpha = 0;
        this._currentPanel.visible = true;
        this._currentPanel.scale.x = startScale;
        this._currentPanel.scale.y = startScale;

        this._winAwardTextBack.scale.x = 0.5;
        this._winAwardTextBack.scale.y = 0.5;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        this._winAwardTextBack.set(0);

        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
        this._winAwardTextBack.alpha = 1;
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('BIGWIN');
      }
    }

    update_bigWin() {
      const startScale = 0.4;
      const endScale = 1;
      const totalScaleTravel = startScale - endScale;

      // do the count up - this is zero to big win threshold
      // dim the screen
      if (this.phase.enter()) {
        musicManager.startCountUp();

        this.allowSkipWin = true;

        // set up panels
        const threshold = gameController.globalHelperGetStake() * this.getHugeWinThreshold();
        const previousThreshold = 0;
        const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;

        this._winAwardTextBack.countUp(amountToCountUp, 1600);

        this.bounceCounter = 0;
      }

      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        musicManager.endCountUp();
        this._winAwardTextBack.cancelCountUp();
      }

      // old stage three
      if (this.phase.timed(300)) {
        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);

        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        this.bounceCounter += this.bounceRate;
        this._currentPanel.scale.y = this._currentPanel.scale.x =
          endScale * (1 - Math.abs(Math.sin(this.bounceCounter)) * 0.2);
        if (this._winAwardTextBack.Props.isCounting === false) {
          musicManager.endCountUp();
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('BOUNCEANDGROW');
      }

      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        if (this.winAmount >= gameController.globalHelperGetStake() * this.getHugeWinThreshold()) {
          this.currentState = 'HUGEWIN';
        } else {
          this._thresholdMultiplier = this.getBigWinThreshold();
          this.currentState = 'ENDSTAGE';
        }
      }
    }

    update_hugeWin() {
      const startScale = 0.4;
      const endScale = 1;
      const totalScaleTravel = startScale - endScale;

      if (this.phase.enter()) {
        musicManager.startCountUp();

        this._previousPanel = this._bigWinTextContainer;
        this._currentPanel = this._hugeWinTextContainer;
        this._currentPanel.alpha = 0;
        this._currentPanel.visible = true;
        this._currentPanel.scale.x = startScale;
        this._currentPanel.scale.y = startScale;

        const threshold = gameController.globalHelperGetStake() * this.getMassiveWinThreshold();
        const previousThreshold = gameController.globalHelperGetStake() * this.getHugeWinThreshold();

        const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;

        this._winAwardTextBack.countUp(amountToCountUp, 1600);

        this.bounceCounter = 0;
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        musicManager.endCountUp();
        this._winAwardTextBack.cancelCountUp();
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(200)) {
        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);
        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      if (this.phase.once()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        this.bounceCounter += this.bounceRate;
        this._currentPanel.scale.y = this._currentPanel.scale.x =
          endScale * (1 - Math.abs(Math.sin(this.bounceCounter)) * 0.2);
        if (this._winAwardTextBack.Props.isCounting === false) {
          musicManager.endCountUp();
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('BOUNCEANDGROW');
      }

      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        // which state next
        if (this.winAmount >= gameController.globalHelperGetStake() * this.getMassiveWinThreshold()) {
          this.currentState = 'MASSIVEWIN';
        } else {
          this._thresholdMultiplier = this.getHugeWinThreshold();
          this.currentState = 'ENDSTAGE';
        }
      }
    }

    update_massiveWin() {
      const startScale = 0.4;
      const endScale = 1;
      const totalScaleTravel = startScale - endScale;

      if (this.phase.enter()) {
        musicManager.startCountUp();

        this._previousPanel = this._hugeWinTextContainer;
        this._currentPanel = this._massiveWinTextContainer;
        this._currentPanel.alpha = 0;
        this._currentPanel.visible = true;
        this._currentPanel.scale.x = startScale;
        this._currentPanel.scale.y = startScale;

        const threshold = gameController.globalHelperGetStake() * this.getEpicWinThreshold();
        const previousThreshold = gameController.globalHelperGetStake() * this.getMassiveWinThreshold();

        const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;

        this._winAwardTextBack.countUp(amountToCountUp, 1600);

        this.bounceCounter = 0;
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        musicManager.endCountUp();
        this._winAwardTextBack.cancelCountUp();
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(500)) {
        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);
        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      if (this.phase.once()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        this.bounceCounter += this.bounceRate;
        this._currentPanel.scale.y = this._currentPanel.scale.x =
          endScale * (1 - Math.abs(Math.sin(this.bounceCounter)) * 0.2);
        if (this._winAwardTextBack.Props.isCounting === false) {
          musicManager.endCountUp();
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('BOUNCEANDGROW');
      }

      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        // which state next
        if (this.winAmount >= gameController.globalHelperGetStake() * this.getEpicWinThreshold()) {
          this.currentState = 'EPICWIN';
        } else {
          this._thresholdMultiplier = this.getMassiveWinThreshold();
          this.currentState = 'ENDSTAGE';
        }
      }
    }

    update_epicWin() {
      const startScale = 0.4;
      const endScale = 1;
      const totalScaleTravel = startScale - endScale;

      if (this.phase.enter()) {
        musicManager.startCountUp();

        this._starParticles.particleEmitter.emit = true;
        this._starParticles.visible = true;

        this._previousPanel = this._massiveWinTextContainer;
        this._currentPanel = this._epicWinTextContainer;
        this._currentPanel.alpha = 0;
        this._currentPanel.visible = true;
        this._currentPanel.scale.x = startScale;
        this._currentPanel.scale.y = startScale;

        const previousThreshold = gameController.globalHelperGetStake() * this.getEpicWinThreshold();
        const threshold = gameController.globalHelperGetStake() * this.getMonsterWinThreshold();
        const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;

        this._winAwardTextBack.countUp(amountToCountUp, 1600);

        this.bounceCounter = 0;
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        musicManager.endCountUp();
        this._winAwardTextBack.cancelCountUp();
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(500)) {
        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);
        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      if (this.phase.once()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        this.bounceCounter += this.bounceRate;
        this._currentPanel.scale.y = this._currentPanel.scale.x =
          endScale * (1 - Math.abs(Math.sin(this.bounceCounter)) * 0.2);
        if (this._winAwardTextBack.Props.isCounting === false) {
          musicManager.endCountUp();
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('BOUNCEANDGROW');
      }

      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        // which state next
        if (this.winAmount >= gameController.globalHelperGetStake() * this.getMonsterWinThreshold()) {
          this.currentState = 'MONSTERWIN';
        } else {
          this._thresholdMultiplier = this.getEpicWinThreshold();
          this.currentState = 'ENDSTAGE';
        }
      }
    }

    update_monsterWin() {
      const startScale = 0.4;
      const endScale = 1;
      const totalScaleTravel = startScale - endScale;

      if (this.phase.enter()) {
        musicManager.startCountUp();

        this._previousPanel = this._epicWinTextContainer;
        this._currentPanel = this._monsterWinTextContainer;
        this._currentPanel.alpha = 0;
        this._currentPanel.visible = true;
        this._currentPanel.scale.x = startScale;
        this._currentPanel.scale.y = startScale;

        const threshold = gameController.globalHelperGetStake() * this.getMonsterWinThreshold();
        const amountToCountUp = this.winAmount - threshold;

        this._winAwardTextBack.countUp(amountToCountUp, 1600);

        this.bounceCounter = 0;
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState('BOUNCEANDGROW');
        musicManager.endCountUp();
        this._winAwardTextBack.cancelCountUp();
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(500)) {
        const scaleTravel = totalScaleTravel * (1 - this.phase.Progress);
        this._currentPanel.alpha = this.phase.Progress;
        this._currentPanel.scale.x = endScale + scaleTravel;
        this._currentPanel.scale.y = endScale + scaleTravel;
      }

      if (this.phase.once()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        this.bounceCounter += this.bounceRate;
        this._currentPanel.scale.y = this._currentPanel.scale.x =
          endScale * (1 - Math.abs(Math.sin(this.bounceCounter)) * 0.2);
        if (this._winAwardTextBack.Props.isCounting === false) {
          musicManager.endCountUp();
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('BOUNCEANDGROW');
      }

      if (this.phase.exit()) {
        this._currentPanel.alpha = 1;
        this._currentPanel.scale.x = endScale;
        this._currentPanel.scale.y = endScale;

        this._thresholdMultiplier = this.getMonsterWinThreshold();
        this.currentState = 'ENDSTAGE';
      }
    }

    update_bounceAndGrow() {
      const endScale = 1;

      if (this.phase.enter()) {
      }

      if (this.currentState === 'ENDSTAGE') {
        if (this.phase.timed(1000)) {
          this.bounceCounter += this.bounceRate;
          this._currentPanel.scale.y = this._currentPanel.scale.x =
            endScale * (1 - Math.abs(Math.sin(this.bounceCounter)) * 0.2);
        }
      }

      if (this.phase.once()) {
        let panel = this._currentPanel;
        panel.Props.orgScaleX = panel.scale.x;
        panel.Props.orgScaleY = panel.scale.y;

        gsap.to(panel, {
          pixi: { scaleX: 4, scaleY: 4, alpha: 0 },
          duration: 1,
          onComplete: () => {
            panel.Props.orgScaleX = panel.scale.x;
            panel.Props.orgScaleY = panel.scale.y;
            panel.alpha = 0;
          },
        });
      }

      if (this.skipWin) {
        this.stateMachine.switchState(this.currentState);
      }

      // move to the next stage of the big win sequence
      if (this.phase.once()) {
        this.stateMachine.switchState(this.currentState);
      }

      if (this.phase.exit()) {
      }
    }

    update_endStage() {
      if (this.phase.once()) {
        this.stateMachine.switchState('IDLE');
      }

      if (this.phase.exit()) {
        this.showEndScreen();
      }
    }

    showEndScreen() {
      musicManager.onBigWinEnd();

      const self = this;
      gameData.winningsMeter.set(this.winAmount);

      // Pause to let player see their win
      timerManager.addTimer(
        1500,
        function (progress) {},
        function () {
          self.outro();
        }
      );
    }

    outro() {
      let self = this;

      timerManager.addTimer(
        1000,
        function (progress) {
          self.alpha = 1 - progress;
          self._dimScreen.setAlpha(0.7 * (1 - progress));
        },
        function () {
          self._currentPanel.visible = false;
          self._currentPanel.alpha = 1;
          self._currentPanel.scale.x = 1;
          self._currentPanel.scale.y = 1;

          self.alpha = 1;
          self.visible = false;

          self._electricParticles.particleEmitter.emit = false;
          self._electricParticles.visible = false;

          self._starParticles.particleEmitter.emit = false;
          self._starParticles.visible = false;

          self._winAwardTextBack.alpha = 1;
          self._winAwardTextBack.visible = false;

          self._dimScreen.show(false);

          self._rotate = false;

          self.isActive = false;

          self._skipBigWinBox.alpha = 0;
          self._skipBigWinBox.visible = false;
          self._skipBigWinBox.interactive = false;

          self.callback();
          self._glowTween.pause();
        }
      );
      // gameData.musicManager.setIdleMusic();
      // gameData.musicManager.changeLevel('base', 4);
    }

    skip() {
      if (this.canSkip()) {
        const self = this;
        timerManager.addTimer(
          500,
          function () {},
          function () {
            self.skipWin = true;
          }
        );
      }
    }
  }

  var bigWinCreator = function (json) {
    return new BigWinNew();
  };

  var bigWinInitialiser = function (json, bigWin) {};

  var bigWinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('bigWinNew', bigWinCreator, bigWinInitialiser, bigWinFilesRequired);
})();
